<template>
  <div class="agency ">
    <headd></headd>
    <indexswiper :swiper_list="swiper_list"></indexswiper>
    <div class="agency_mo container">
      <div class="container-head">
        <div class="head-left">
          <div class="icon">
            <img src="../../static/otherpage/icon_t_1.png" />
          </div>
          热门专区
        </div>
      </div>
      <modulelist1 :modulelist="combos"></modulelist1>
    </div>
    <indexbanner :adbannerlist="banner_1"></indexbanner>
    <div class="agency_recommd container">
      <div class="container-head">
        <div class="head-left">
          <div class="icon">
            <img src="../../static/otherpage/icon_t_8.png" />
          </div>
          口碑推荐
        </div>
      </div>
      <modulelist3 :modulelist="ServiceCombo"></modulelist3>
    </div>
    <dynamicimg :datainfo="dy_title_t1"></dynamicimg>
    <anews :datainfo="dy_title_t2"></anews>
    <dynamicimg :datainfo="dy_title_t3"></dynamicimg>
    <maybe :is_include="name"></maybe>
    <foot></foot>
  </div>
</template>

<script>
import indexswiper from "../components/indexswiper.vue";
import indexbanner from "../components/indexbanner.vue";
import maybe from "../components/maybe.vue";
import anews from "../components/anews.vue";
import dynamicimg from "../components/dynamicimg.vue";
import modulelist1 from "../components/modulelist1.vue";
import modulelist3 from "../components/modulelist3.vue";
import headd from "../components/head";
import foot from "@/components/foot";
import {
  getjizhangCombobanner,
  getjizhangCombo,
  getjizhangServiceCombo,
  getjizhangPageData,
  getappads
} from "./api/api"; //引入api里面定义的方法
import Foot from "../components/foot.vue";
export default {
  data() {
    return {
      name: "代理记账",

      dy_title_t1: {
        icon: "../../static/otherpage/icon_t_4.png",
        title: "",
        pagevalue: ""
      },
      dy_title_t2: {
        icon: "../../static/otherpage/icon_t_9.png",
        title: "",
        pagevalue: {}
      },
      dy_title_t3: {
        icon: "../../static/otherpage/icon_t_7.png",
        title: "",
        pagevalue: ""
      },
      indicatorDots: true,
      autoplay: true,
      interval: 2000,
      duration: 500,
      indicatorColor: "rgba(255, 255, 255, .3)",
      indicatorActivecolor: "#FFFFFF",
      texts: "测试数据",
      swiper_list: [],
      combos: [],
      ServiceCombo: [],
      adbanner_list: [],
      banner_1: []
    };
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    indexbanner,
    indexswiper,
    maybe,
    anews,
    dynamicimg,
    modulelist1,
    modulelist3,
    headd,
    foot
  },
  async mounted() {
    var swiperr = await getjizhangCombobanner();
    this.swiper_list = swiperr.data.data.banner;
    this.$nextTick(function() {
      this.swiper();
    });

    var combos = await getjizhangCombo();
    this.combos = combos.data.data.combos;

    var ServiceCombo = await getjizhangServiceCombo();
    this.ServiceCombo = ServiceCombo.data.data.combos;

    var regPageData = await getjizhangPageData();
    var data = regPageData.data.data;

    this.dy_title_t1 = data.t1;
    this.dy_title_t2 = data.t2;
    this.dy_title_t3 = data.t3;
    this.$set(this.dy_title_t1, "icon", "../../static/otherpage/icon_t_4.png");
    this.$set(this.dy_title_t2, "icon", "../../static/otherpage/icon_t_9.png");
    this.$set(this.dy_title_t3, "icon", "../../static/otherpage/icon_t_7.png");

    var appads1 = await getappads("dljz_ads");
    this.banner_1 = appads1.data.data.appads;
  },
  methods: {
    swiper() {
      new Swiper(".banner", {
        loop: true,
        observer: true,
        pagination: ".swiper-pagination",
        paginationClickable: true,
        autoplay: 5000
      });
    }
  }
};
</script>

<style lang="less">
.container {
  margin: 30rpx 32rpx;
  width: 686rpx;
}

.agency {
  flex-direction: column;
  @media (max-width: 991px) {
    width: 6.86rem;
  }
  margin: auto;

  .agency_mo {
    flex-direction: column;
    margin-bottom: 20rpx;
  }

  .agency_recommd {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/agency.vue